import Collection from './collection.js';
import ItemYearlyTotal from 'newModels/item-yearly-total.js';
import PayrollItemFilters from './mixins/payroll-item-filters.js';

export default class ItemYearlyTotals extends PayrollItemFilters(Collection) {
    url() {
        if (this.employee) {
            return `${this.employee.url()}/totals`;
        }

        return '/ItemYearlyTotals';
    }

    initialize(models, {employee = null, year = null} = {}) {
        super.initialize(...arguments);
        this.model = ItemYearlyTotal;
        this.employee = employee;
        this.year = year;

        if (!this.options.sortKey) {
            this.options.sortKey = 'createdAt';
        }
        return this;
    }

    comparator(model) {
        // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
        const weightByType = {
            base:      100,
            mtd:       90,
            epf:       80,
            socso:     70,
            zakat:     60,
            addition:  50,
            benefit:   40,
            deduction: 30
        };
        // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
        const item = model.getPayrollItem();

        return -(weightByType[item.get('type')] || 0);
    }

    fetchForPreviousPayslips(year = null) {
        const payrollItems = app.payrollItems.filter(model => {
            const type = model.get('type');
            return (
                (
                    ['hrdf', 'eis', 'epf', 'socso'].includes(type) &&
                    model.get('isNet') === true
                ) ||
                ['hrdf', 'eis', 'epf', 'socso'].indexOf(type) < 0
            );
        });
        const payrollItemIds = payrollItems.map(i => i.id);
        const filter = {
            where: {
                payrollItemId: {inq: payrollItemIds}
            },
            limit: 9999
        };

        if (year && typeof year === 'number') {
            this.year = year;
        }

        if (this.year) {
            filter.where.year = this.year;
        }

        return this.fetch({filter: filter}).then(() => this);
    }

    clearAmounts({current = null} = {}) {
        this.forEach(model => {
            const monthly = [...Array(12).keys()].map(() => 0);

            if (current !== false) {
                model.set({
                    amount: 0,
                    monthly: monthly
                });
            }

            if (current !== true) {
                model.set({
                    prevEmploymentAmount: 0,
                    prevEmploymentMonthly: monthly
                });
            }
        });

        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/item-yearly-totals.js